import styled from 'styled-components';
import SubTitle from 'js/components/core/SteppedPage/SubTitle';

export default styled(SubTitle)`
  margin-bottom: 2rem;
`;
